import Vue from 'vue';
import Router from 'vue-router';
import configHttp from '../../configHttp.js'
import configHttpProduct from '../../configHttpProduct.js'
Vue.use(Router);

export default new Router({
	routes: [{
			path: '/',
			component: () => import('../components/layout/Home'),
			redirect:  (configHttp.projectType == 'Amat' && configHttp.ssoSwitch) ? '/login_Fin' : '/Login',
			meta: {
				title: ''
			},
			children: [{
					path: '/home',
					component: () => import( /* webpackChunkName: "home" */
						'../components/page/home/index.vue'),
					meta: {
						title: '首页',
						roles: ['home']
					},
				}, {
					path: '/FileImport',
					component: () => import('../components/page/VoucherImport/FileImport/index.vue'),
					meta: {
						title: '文件导入',
						roles: ['FileImport']
					},
				},
				{
					path: '/VoucherTemplates',
					component: () => import(
						'../components/page/VoucherImport/VoucherTemplates/index.vue'),
					meta: {
						title: '凭证模板配置',
						roles: ['VoucherTemplates']
					},
				},
				{
					path: '/CustomImportTask',
					component: () => import(
						'../components/page/VoucherImport/CustomImportTask/index.vue'),
					meta: {
						title: '定制导入任务',
						roles: ['CustomImportTask']
					},
				},
				{
					path: '/VoucherQuery',
					component: () => import(
						'../components/page/AccountingQuery/VoucherQuery/index.vue'),
					meta: {
						title: '凭证查询',
						roles: ['VoucherQuery']
					},
				},
				{
					path: '/CFDirectMethodData',
					component: () => import(
						'../components/page/AccountingQuery/CFDirectMethodData/index.vue'),
					meta: {
						title: 'CF直接法数据',
						roles: ['CFDirectMethodData']
					},
				},
				{
					path: '/VPSupplierData',
					component: () => import(
						'../components/page/AccountingQuery/VPSupplierData/index.vue'),
					meta: {
						title: 'VP供应商数据',
						roles: ['VPSupplierData']
					},
				},
				{
					path: '/VoucherDetail',
					component: () => import(
						'../components/page/AccountingQuery/VoucherDetail/index.vue'),
					meta: {
						title: '凭证详情',
						roles: ['VoucherDetail']
					},
				},
				{
					path: '/PreviewVoucher',
					component: () => import(
						'../components/page/AccountingQuery/PreviewVoucher/index.vue'),
					meta: {
						title: '预览凭证',
						roles: ['PreviewVoucher']
					},
				},
				{
					path: '/GLView',
					component: () => import('../components/page/AccountingQuery/GLView/index.vue'),
					meta: {
						title: '总账查看',
						roles: ['GLView']
					},
				},
				{
					path: '/SubLedgerTable',
					component: () => import('../components/page/AccountingQuery/SubLedgerTable/index.vue'),
					meta: {
						title: '明细账',
						roles: ['SubLedgerTable']
					},
				},
				{
					path: '/ReportTask',
					component: () => import('../components/page/ReportCenter/ReportTask/index.vue'),
					meta: {
						title: '报表任务',
						roles: ['ReportTask']
					},
				},
				{
					path: '/BalanceSheet',
					component: () => import('../components/page/ReportCenter/BalanceSheet/index.vue'),
					meta: {
						title: '资产负债表',
						roles: ['BalanceSheet']
					},
				},
				{
					path: '/VarianceAnalysis',
					component: () => import(
						'../components/page/ReportCenter/VarianceAnalysis/index.vue'),
					meta: {
						title: configHttp.projectType == 'Amat' ? '科目余额' : '科目余额差异分析',
						roles: ['VarianceAnalysis']
					},
				},
				{
					path: '/DetailedStatement',
					component: () => import(
						'../components/page/ReportCenter/DetailedStatement/index.vue'),
					meta: {
						title: '明细账报表',
						roles: ['DetailedStatement']
					},
				},
				{
					path: '/VoucherReport',
					component: () => import('../components/page/ReportCenter/VoucherReport/index.vue'),
					meta: {
						title: '凭证报表',
						roles: ['VoucherReport']
					},
				},
				{
					path: '/VoucherData',
					component: () => import('../components/page/ReportCenter/VoucherData/index.vue'),
					meta: {
						title: '凭证数据',
						roles: ['VoucherData']
					},
				},
				{
					path: '/CustomReport',
					component: () => import('../components/page/ReportCenter/CustomReport/index.vue'),
					meta: {
						title: '定制报表',
						roles: ['CustomReport']
					},
				},
				{
					path: '/ConfigurationCenter',
					component: () => import('../components/page/ConfigurationCenter/index.vue'),
					meta: {
						title: '配置中心',
						roles: ['ConfigurationCenter']
					},
				},
				{
					path: '/EntityManagement',
					component: () => import(
						'../components/page/ConfigurationCenter/Organization/EntityManagement/index.vue'
					),
					meta: {
						title: '实体管理',
						roles: ['EntityManagement']
					},
				},
				{
					path: '/UserManagement',
					component: () => import(
						'../components/page/ConfigurationCenter/Organization/UserManagement/index.vue'
					),
					meta: {
						title: '用户管理',
						roles: ['UserManagement']
					},
				},
				{
					path: '/PermissionManagement',
					component: () => import(
						'../components/page/ConfigurationCenter/Organization/PermissionManagement/index.vue'
					),
					meta: {
						title: '权限管理',
						roles: ['PermissionManagement']
					},
				},
				{
					path: '/UserEntityConfiguration',
					component: () => import(
						'../components/page/ConfigurationCenter/Organization/UserEntityConfiguration/index.vue'
					),
					meta: {
						title: '用户实体配置',
						roles: ['UserEntityConfiguration']
					},
				},
				{
					path: '/ScheduledTasks',
					component: () => import(
						'../components/page/ConfigurationCenter/Organization/ScheduledTasks/index.vue'
					),
					meta: {
						title: '定时任务实例管理',
						roles: ['ScheduledTasks']
					},
				},
				{
					path: '/ChineseSubjects',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/ChineseSubjects/index.vue'
					),
					meta: {
						title: '中方科目',
						roles: ['ChineseSubjects']
					},
				},
				{
					path: '/AccountMapping',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/AccountMapping/index.vue'
					),
					meta: {
						title: '科目映射',
						roles: ['AccountMapping']
					},
				},
				{
					path: '/AnalysisCode',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/AnalysisCode/index.vue'
					),
					meta: {
						title: '分析代码管理',
						roles: ['AnalysisCode']
					},
				},
				{
					path: '/FiscalYearSetup',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/FiscalYearSetup/index.vue'
					),
					meta: {
						title: '财年设置',
						roles: ['FiscalYearSetup']
					},
				},
				{
					path: '/AnalysisFieldName',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/AnalysisFieldName/index.vue'
					),
					meta: {
						title: '分析字段名称',
						roles: ['AnalysisFieldName']
					},
				},
				{
					path: '/CurrencySettings',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/CurrencySettings/index.vue'
					),
					meta: {
						title: '币种设置',
						roles: ['CurrencySettings']
					},
				},
				{
					path: '/TemplateFile',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/TemplateFile/index.vue'
					),
					meta: {
						title: '模板文件管理',
						roles: ['TemplateFile']
					},
				},
				{
					path: '/GeneralAuxiliaryConfiguration',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/GeneralAuxiliaryConfiguration/index.vue'
					),
					meta: {
						title: '通用辅助配置',
						roles: ['GeneralAuxiliaryConfiguration']
					},
				},
				{
					path: '/CFisDirectlyConfigured',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/CFisDirectlyConfigured/index.vue'
					),
					meta: {
						title: 'CF直接法配置',
						roles: ['CFisDirectlyConfigured']
					},
				},
				{
					path: 'ACSetManagement',
					component: () => import(
						'../components/page/ConfigurationCenter/BusinessManagement/ACSetManagement/index.vue'
					),
					meta: {
						title: '账套管理',
						roles: ['ACSetManagement']
					},
				},
			]
		},
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "home" */ '../components/page/Login'),
			meta: {
				title: '登录'
			},
		},
		{
			path: '/login_Fin',
			component: () => import( /* webpackChunkName: "home" */ '../components/page/login_Fin'),
			meta: {
				title: '登录',
				roles: ['login_Fin']
			},
		},
		{
			path: '/login_Product',
			component: () => import( /* webpackChunkName: "home" */ '../components/page/login_Product'),
			meta: {
				title: '登录',
				roles: ['login_Product']
			},
		},
	]
});
